import { defineNuxtPlugin } from '#app/nuxt'
import { LazyPuLink, LazyError500, LazyErrorGeneral, LazyErrorMessage, LazyI18nT, LazyNuxtLazyHydrate2, LazyNuxtLazyHydrate3, LazyNuxtToMeta, LazyPaginationControls, LazyPuFlickity, LazyTranslate, LazyAiSearchConfirmDialog, LazyAiSearchLoading, LazyAsyncComponentSkeleton, LazyBaseButton, LazyBaseCheckbox, LazyBaseCountry, LazyBaseEmail, LazyBaseInput, LazyBaseMultiCheckbox, LazyBasePassword, LazyBaseRadio, LazyBaseRadioOptions, LazyBaseSelect, LazyBaseSubmitButton, LazyBaseTextarea, LazyCopyButton, LazyInputErrorMessage, LazyTimeAgo, LazyAmendBookingMessage, LazyAmendBooking, LazyBalancePaymentTerms, LazyBookingDetails, LazyCancelBooking, LazyBaseBreadcrumbsGenerator, LazyBreadcrumbsGenerator, LazyCampsiteBreadcrumbs, LazySearchBreadcrumbs, LazySearchBreadcrumbsGenerator, LazySecondaryBreadcrumbs, LazySingleCategoryBreadcrumbs, LazyArrivalTaxTranslation, LazyCampsiteInfoDirections, LazyCampsiteInformation, LazyCampsiteNotices, LazyLastBooked, LazyNewCampsiteBadge, LazyUnitPerPitch, LazyUnitPerPitchPopup, LazyUnitPerPitchShortVersion, LazyBaseCampsiteCard, LazyPuCampsiteCard, LazyPuCampsiteCardLocationSection, LazyPuCampsitePhotosProvider, LazyPuCampsitePriceCard, LazyPuCategoryIcons, LazyPuNutshells, LazyPuPricingResults, LazyPuRatingBubble, LazyCompulsoryExtras, LazyExtraDescription, LazyCampsiteNameSuggest, LazyChangeCustomerTypeLink, LazyContactForm, LazyContactThanks, LazyCustomerType, LazyMostPopularQuestions, LazyReasonSelect, LazyRegisteredCompanyInfo, LazyBaseList, LazyBaseTree, LazyDatesWizardBody, LazyDatesWizardBodyClearButton, LazyDatesWizardBodyHeaderRange, LazyDatesWizardKeys, LazyDatesWizardSummary, LazyDatesWizardSummaryDesktop, LazyBaseExtra, LazyBookingExtras, LazyFestivalCard, LazyPuFlag, LazyGuestsForm, LazyGeolocationCheckbox, LazyGeolocationState, LazyGlampingGuides, LazyGlampingPopularDestinations, LazyGlampingPopularSearches, LazyAboutPitchup, LazyAccommodationTypes, LazyArticleList, LazyCampsiteOwner, LazyHomepageBackground, LazyHomepageMain, LazyPopularFeatures, LazyPopularSearches, LazyPopularSearchesGlamping, LazyTopDestinations, LazySocialProofEs, LazySocialProofFr, LazySocialProofIt, LazySocialProofOthers, LazySocialProofUsa, LazySocialProof, LazyAccountHome, LazyAppFooter, LazyAppFooterDesktop, LazyAppHeaderDesktop, LazyAppHeader, LazyCopyright, LazyFeefoBadge, LazyFooterLinks, LazyFooterLinksDesktop, LazyPaymentTypes, LazyRecentCampsites, LazyVersion, LazyAppMenu, LazyAppMenuAboutUs, LazyAppMenuCategories, LazyAppMenuInternationalization, LazyAppMenuSocialLinks, LazyCurrencySwitchMenu, LazyMegaMenu, LazyPopularDestinations, LazyAppMenuLocationNode, LazyAppMenuLocations, LazyAppMenuLocationsTree, LazyFacebookContinueButton, LazyFacebookLoginButton, LazyGoogleLoginButton, LazyGoogleOneTap, LazyLoginForm, LazyLoginMain, LazySocialLogin, LazyStateMatches, LazyStateStringsMatches, LazyPDateRange, LazyCampsiteDetail, LazyCategorySearch, LazyFallback, LazyGlampingCategorySearch, LazySearchPage, LazyGlamping2, LazyRegionalWinners, LazyReviewAwardsIntro, LazyReviewAwardsPagesNav, LazyReviewAwardsTopSites, LazyReviewDetails, LazySearchSummaryBar, LazySearchSummaryBarAction, LazySearchSummaryBarDetails, LazySearchSummaryBarDetailsBounds, LazySearchSummaryBarDetailsCalendar, LazySearchSummaryBarDetailsCalendarSameMonth, LazySearchSummaryBarDetailsCategories, LazySearchSummaryBarDetailsFacets, LazySearchSummaryBarDetailsGuests, LazySearchSummaryBarDetailsPriceRange, LazySearchSummaryBarFilters, LazySearchSummaryBarLinkMatches, LazySingleStar, LazyStarRating, LazyStarRatingAccessible, LazyBackToTop, LazyBasePhone, LazyDeleteButtonWithPrompt, LazyError, LazyFloatingWindow, LazyLoading, LazyLoadingSpinner, LazyNumberStepper, LazyPuAccordion, LazyPuAccordionStateless, LazyPuDate, LazyPuModal, LazyPuModalNoHash, LazyPuPopover, LazyPuPrice, LazyPuPriceLosenge, LazyPuPriceRounded, LazyPuSlideoutPanel, LazyPuTimezone, LazyPuUtcDate, LazyUiCollapse, LazyDotBar, LazyAccountDashboard, LazyAccountSectionsMenu, LazyNewUser, LazyRecentSearches, LazyUserAccountFooter, LazyUserAccountSection, LazyUserAccountUsersInfo, LazyUserAvatar, LazyUserChangePassword, LazyUserDetails, LazyAllocationAlertForm, LazyNotifyMe, LazyBookingCampsiteDetails, LazyBookingCancellationPolicy, LazyBookingCosts, LazyBookingDateChanged, LazyBookingDisallowedSubcategories, LazyBookingEditIcon, LazyBookingEstimateTimeOfArrival, LazyBookingForm, LazyBookingLoadingErrorState, LazyBookingLoadingState, LazyBookingMain, LazyBookingMessageModal, LazyBookingMyDetails, LazyBookingNotices, LazyBookingOtherDetails, LazyBookingParty, LazyBookingPartyIcon, LazyBookingPaymentProcessingMain, LazyBookingPaypalButton, LazyBookingPitchDetails, LazyBookingReservationDetails, LazyBookingStayDetails, LazyBookingSubmitErrorState, LazyBookingTaxTerms, LazyBookingThanksPageNavigate, LazyBookingTimeUntilHoliday, LazyBookingTotalCost, LazyBookingTotalStay, LazyAdditionalTaxes, LazyArrivalTaxes, LazyExtraChoice, LazyExtraChoices, LazyAccountSection, LazyLoginModal, LazyPasswordSection, LazyBookingArrivalTaxes, LazyBookingCityTax, LazyBookingExclusiveTaxes, LazyBookingPaymentDeferred, LazyBookingPaymentImmediate, LazyBookingPaymentPitchupOnly, LazyApplePayButton, LazyBasePaymentOption, LazyGooglePayButton, LazyNewCardPaymentOption, LazyNewCardPaymentOptionValidationErrors, LazyPaymentCard, LazyPaymentCardForm, LazyPaymentCardSaveForm, LazyPaymentCardSaveFormInfo, LazyPaymentRequestButtonElement, LazyPaymentsMethodsForm, LazyPaymentsMethodsForm2, LazyRequestPaymentButton, LazyStripePaymentElement, LazyStripeProvider, LazyStoredCardPaymentOption, LazyStoredPaymentCardsSelector, LazyAlbumPhotos, LazyAlbumVideo, LazyCampsiteAlbums, LazyCampsiteDescriptionDesktop, LazyCampsiteDetailBackButton, LazyCampsiteDetailBookableListing, LazyCampsiteDetailCardContent, LazyCampsiteDetailFaq, LazyCampsiteDetailFreeListing, LazyCampsiteDetailFreeListingPromo, LazyCampsiteDetailHeroDesktop, LazyCampsiteDetailLocationRow, LazyCampsiteDetailSearchBreadcrumbs, LazyCampsiteNextOpen, LazyCampsitePageNavigation, LazyCampsitePitchtypeDetailMain, LazyNearbyBookable, LazyNearbyBookableFooter, LazyNearbyBookableHeader, LazyNearbyBookableList, LazyNearbyBookableMap, LazyMiniCard, LazyMiniCardDistance, LazyMiniCardPrice, LazyMiniCardPriceDated, LazyPitchtypeBookingLink, LazyPitchtypeDatepickerAvailability, LazyPitchtypeDetailClose, LazyPitchtypeDetailsAvailabilitySection, LazyPitchtypeEditAvailabilitySearchButton, LazyPitchtypeMiniAvailabilityCalendar, LazyPitchtypeMiniAvailabilityCalendarWithAvailability, LazyPitchtypeAlternativeStays, LazyPitchtypeMiniAvailabilityCalendarDay, LazyPitchtypeMiniAvailabilityCalendarMonth, LazyPitchtypeMiniAvailabilityCalendarWeek, LazyCampsiteDetailsPromoPages, LazyCampsiteImageUploader, LazyFilestack, LazyUploadedImagePreview, LazyCampsiteAddressAndMap, LazyCampsiteMapModal, LazyCampsiteParty, LazyDirectionsButton, LazyEditSearchButton, LazyInlineGallery, LazyMatchingCriteriaCountText, LazyNearbyTransport, LazyPitchTypePhotos, LazyPitchTypesGroup, LazyPitchTypesList, LazyPitchTypesSection, LazyPrimaryPhoto, LazyPrimaryPhotoAndGallery, LazySearchInlineGallery, LazySubsectionsGroup, LazyBasePitchTypeCard, LazyCancellationPolicyPopover, LazyCostsBreakdown, LazyDefaultCostsBreakdown, LazyPitchTypeCardDated, LazyPitchTypeCardNonDated, LazyPitchTypeDetail, LazyPitchTypeDimensions, LazyPitchTypeSeoCard, LazyPitchTypeSummary, LazyArrivalTax, LazyAvailabilityErrorState, LazyBookingBalance, LazyCapacity, LazyCapacityRules, LazyChargeTypeState, LazyExtraDated, LazyExtraNonDated, LazyExtras, LazyFacilities, LazyOffersActive, LazyPartyEdit, LazyPersons, LazyPitchTypeAttributes, LazyPitchTypeImage, LazyPitchTypeOffers, LazyPitchTypeState, LazyPitchTypeStatusMsg, LazyPitchtypesCompulsoryExtras, LazyPricingPeriodDated, LazyPricingPeriodNonDated, LazySuperFacilities, LazyTaxes, LazyTotalStay, LazyBedrooms, LazyOtherRestrictions, LazyStripePayment, LazyStripePaymentDeferred, LazyStripePaymentImmediate, LazyStripePaymentPitchupOnly, LazyCampsiteActivitiesList, LazyCampsiteArrivalTax, LazyCampsiteCycleRoutes, LazyCampsiteDescription, LazyCampsiteDescriptionText, LazyCampsiteDirections, LazyCampsiteFeatures, LazyCampsiteFestivals, LazyCampsiteLocalAttractions, LazyCampsiteLocalAttractionsSubsection, LazyCampsiteLocation, LazyCampsiteNationalTrust, LazyCampsiteNoDescription, LazyCampsiteNoticesSubsection, LazyCampsiteOffers, LazyCampsiteOffersSubsection, LazyCampsitePaymentMethods, LazyCampsitePolicies, LazyCampsiteReviewsSubsection, LazyCampsiteSubsection, LazyCampsiteTaxTerms, LazyCampsiteVisitBritain, LazyCampsiteWaterQuality, LazyDistancesNote, LazyPaymentTerms, LazyPermittedArrivalDepartureTimes, LazyPermittedArrivalDepartureTimesSection, LazySiteTypes, LazyCampsiteTermsAndConditions, LazyCampsiteVideo, LazyCampsiteReviewsFilters, LazyCampsiteReviewsGallery, LazyCampsiteReviewsGalleryFullscreen, LazyCampsiteReviewsNew, LazyCampsiteReviewsSummary, LazyCampsiteReviewsSummaryTxt, LazyCampsiteSingleReview, LazyPuRatingBreakdown, LazyPuRatingsDistribution, LazyPuThemeBreakdown, LazyPuThumbsUp, LazyRatingsDistributionBar, LazyWriteReviewButton, LazyAddCampsiteReviewForm, LazyCampsiteReviewRecommend, LazyReviewStarRating, LazyBrowseAllCategories, LazyCategoriesSelector, LazySelectedCategories, LazyEmailConfirmed, LazyCurrencySwitch, LazyAlgoliaSearch, LazyFaqCategory, LazyFaqMain, LazyFaqStandaloneMain, LazyFavouritesIndex, LazyMyFavourites, LazyAppHeaderFavourites, LazyAppHeaderFavouritesCount, LazyCampsiteFavouriteButton, LazyFavouriteAddForm, LazyFavouriteAddFormWishlist, LazyFavouriteCampsitesList, LazyFavouriteListElement, LazyFavouriteListPrivacyPopover, LazyFavouritesMap, LazyFavouritesOnboarding, LazyNoFavourites, LazyWishlistButton, LazyWishlistElement, LazyWishlistFormInputs, LazyWishlistMain, LazyFlatPageComponent, LazyError404, LazyFooterSeoLinks, LazyGoogleTranslateButton, LazyTranslateToLanguage, LazyLanguageSwitch, LazyMapsPage, LazyMapsPageMobile, LazyMapsMain, LazyPuMapStatic, LazyUkRegionsMap, LazyCampsiteMapCard, LazyCampsiteMapCardButton, LazyCampsiteMapCardPrice, LazyCampsiteResultsMap, LazyCampsitesMap, LazyCampsitesMarkersOnlyMap, LazyPuMap, LazyNationalParks, LazyPagePart, LazyPaymentProcessingMain, LazyPersonalDetailsForm, LazyPersonalDetailsShow, LazyPersonalDetails, LazyAddReviewBanner, LazyAddReviewButton, LazyPostReviewMain, LazyAddAReview, LazyServerErrorMessages, LazyPuBookingLink, LazyPuCampsiteAvailabilityLink, LazyPuCampsiteLink, LazyPuHomepageLink, LazyPuSearchWizardLink, LazyPuSearchLink, LazyResendConfirmationEmailMain, LazyAvailabilityCheckWizardMain, LazyCampsitesSearchWizardMain, LazyCampsitesSearchWizardSearchButton, LazySearchBarDesktop, LazyLocationSection, LazyLocationSectionSuggestableInput, LazyPuAutoSuggest, LazyWithinInput, LazyLocationWizardSuggestionLine, LazyGroupBooking, LazyWizardContainer, LazyWizardFooter, LazySearchWizardHomepageBanner, LazySearchWizardHomepageBannerCategories, LazySearchWizardHomepageBannerOptions, LazySearchWizardHomepageBannerOptionsDates, LazySearchWizardHomepageBannerOptionsParty, LazyAccommodationWizard, LazyAccommodationWizardSummary, LazyDatesWizard, LazyWizardSection, LazyGuestsWizard, LazyGuestsWizardBody, LazyGuestsWizardSummary, LazySearchCountries, LazySearchEngagementDestinations, LazySearchEngagementNarrowLinks, LazySearchMain, LazySearchNavBar, LazySearchProvider, LazySearchResultsDescription, LazySearchResultsEngagementFacets, LazySearchResultsFaq, LazySearchResultsList, LazySearchResultsPaginationControls, LazyFilterAndSortCategories, LazyFilterAndSortFooter, LazyFilterAndSortLocation, LazyFilterAndSortMain, LazyFilterAndSortNavItem, LazyFilterAndSortPrice, LazyFilterAndSortPriceSlider, LazyFilterAndSortPriceSliderHistogram, LazyFilterAndSortRadius, LazyFilterAndSortSortOptions, LazyFilterPanel, LazySortSelect, LazyFilterAndSortFacets, LazyFilterAndSortFacetsGroupDefault, LazyFilterAndSortFacetsGroupRanked, LazyLowResultsAllCountries, LazyLowResultsBounds, LazyLowResultsCategories, LazyLowResultsCitySearch, LazyLowResultsDates, LazyLowResultsFacets, LazyLowResultsHierarchy, LazyLowResultsPoint, LazyLowResultsPriceRange, LazyPuLowResultsSearchLink, LazySearchLowResult, LazySearchSummaryAvailabilitySearch, LazySearchSummaryBookableCountSearch, LazySearchSummaryListing, LazySearchSummaryMain, LazySearchResultsPopularLocations, LazySignupForm, LazyThanksMain, LazyThanksPage, LazyThanksPageContactTheSite, LazyHowDidYouHearAboutUs, LazyBalanceStatusButton, LazyBookingDetail, LazyBookingSummary, LazyCampsiteSummary, LazyChangeCardModal, LazyNextHoliday, LazyUserBookingMain, LazyUserBookingTaxes, LazyUserBookings, LazyUserBookingsMain, LazyChangeEmailMain, LazyChangeEmailForm, LazyChangeEmailPendingEmails, LazyUserAccountDetails, LazyUserDetailsForm, LazyAllocationAlert, LazyLocationAllocationAlert, LazyUserAvailabilityAlertsMain, LazyResetPassword, LazyResetPasswordConfirmation, LazyResetPasswordConfirmationMain, LazyUserReviewsMain, LazyPendingReviews, LazyUserSettingsMain, LazyBookingNotificationsSettings, LazyDistanceUnitSettings, LazyEmailPreferencesSettings, LazyFavouritesSettings, LazyLanguageSettings, LazyMapStyleSettings, LazyRecommendationsAndOffersSettings, LazyTemperatureUnitSettings, LazyWebsiteDataSettings, LazyUserStoredCard, LazyUserStoredCards } from '#components'
const lazyGlobalComponents = [
  ["PuLink", LazyPuLink],
["Error500", LazyError500],
["ErrorGeneral", LazyErrorGeneral],
["ErrorMessage", LazyErrorMessage],
["I18nT", LazyI18nT],
["NuxtLazyHydrate2", LazyNuxtLazyHydrate2],
["NuxtLazyHydrate3", LazyNuxtLazyHydrate3],
["NuxtToMeta", LazyNuxtToMeta],
["PaginationControls", LazyPaginationControls],
["PuFlickity", LazyPuFlickity],
["Translate", LazyTranslate],
["AiSearchConfirmDialog", LazyAiSearchConfirmDialog],
["AiSearchLoading", LazyAiSearchLoading],
["AsyncComponentSkeleton", LazyAsyncComponentSkeleton],
["BaseButton", LazyBaseButton],
["BaseCheckbox", LazyBaseCheckbox],
["BaseCountry", LazyBaseCountry],
["BaseEmail", LazyBaseEmail],
["BaseInput", LazyBaseInput],
["BaseMultiCheckbox", LazyBaseMultiCheckbox],
["BasePassword", LazyBasePassword],
["BaseRadio", LazyBaseRadio],
["BaseRadioOptions", LazyBaseRadioOptions],
["BaseSelect", LazyBaseSelect],
["BaseSubmitButton", LazyBaseSubmitButton],
["BaseTextarea", LazyBaseTextarea],
["CopyButton", LazyCopyButton],
["InputErrorMessage", LazyInputErrorMessage],
["TimeAgo", LazyTimeAgo],
["AmendBookingMessage", LazyAmendBookingMessage],
["AmendBooking", LazyAmendBooking],
["BalancePaymentTerms", LazyBalancePaymentTerms],
["BookingDetails", LazyBookingDetails],
["CancelBooking", LazyCancelBooking],
["BaseBreadcrumbsGenerator", LazyBaseBreadcrumbsGenerator],
["BreadcrumbsGenerator", LazyBreadcrumbsGenerator],
["CampsiteBreadcrumbs", LazyCampsiteBreadcrumbs],
["SearchBreadcrumbs", LazySearchBreadcrumbs],
["SearchBreadcrumbsGenerator", LazySearchBreadcrumbsGenerator],
["SecondaryBreadcrumbs", LazySecondaryBreadcrumbs],
["SingleCategoryBreadcrumbs", LazySingleCategoryBreadcrumbs],
["ArrivalTaxTranslation", LazyArrivalTaxTranslation],
["CampsiteInfoDirections", LazyCampsiteInfoDirections],
["CampsiteInformation", LazyCampsiteInformation],
["CampsiteNotices", LazyCampsiteNotices],
["LastBooked", LazyLastBooked],
["NewCampsiteBadge", LazyNewCampsiteBadge],
["UnitPerPitch", LazyUnitPerPitch],
["UnitPerPitchPopup", LazyUnitPerPitchPopup],
["UnitPerPitchShortVersion", LazyUnitPerPitchShortVersion],
["BaseCampsiteCard", LazyBaseCampsiteCard],
["PuCampsiteCard", LazyPuCampsiteCard],
["PuCampsiteCardLocationSection", LazyPuCampsiteCardLocationSection],
["PuCampsitePhotosProvider", LazyPuCampsitePhotosProvider],
["PuCampsitePriceCard", LazyPuCampsitePriceCard],
["PuCategoryIcons", LazyPuCategoryIcons],
["PuNutshells", LazyPuNutshells],
["PuPricingResults", LazyPuPricingResults],
["PuRatingBubble", LazyPuRatingBubble],
["CompulsoryExtras", LazyCompulsoryExtras],
["ExtraDescription", LazyExtraDescription],
["CampsiteNameSuggest", LazyCampsiteNameSuggest],
["ChangeCustomerTypeLink", LazyChangeCustomerTypeLink],
["ContactForm", LazyContactForm],
["ContactThanks", LazyContactThanks],
["CustomerType", LazyCustomerType],
["MostPopularQuestions", LazyMostPopularQuestions],
["ReasonSelect", LazyReasonSelect],
["RegisteredCompanyInfo", LazyRegisteredCompanyInfo],
["BaseList", LazyBaseList],
["BaseTree", LazyBaseTree],
["DatesWizardBody", LazyDatesWizardBody],
["DatesWizardBodyClearButton", LazyDatesWizardBodyClearButton],
["DatesWizardBodyHeaderRange", LazyDatesWizardBodyHeaderRange],
["DatesWizardKeys", LazyDatesWizardKeys],
["DatesWizardSummary", LazyDatesWizardSummary],
["DatesWizardSummaryDesktop", LazyDatesWizardSummaryDesktop],
["BaseExtra", LazyBaseExtra],
["BookingExtras", LazyBookingExtras],
["FestivalCard", LazyFestivalCard],
["PuFlag", LazyPuFlag],
["GuestsForm", LazyGuestsForm],
["GeolocationCheckbox", LazyGeolocationCheckbox],
["GeolocationState", LazyGeolocationState],
["GlampingGuides", LazyGlampingGuides],
["GlampingPopularDestinations", LazyGlampingPopularDestinations],
["GlampingPopularSearches", LazyGlampingPopularSearches],
["AboutPitchup", LazyAboutPitchup],
["AccommodationTypes", LazyAccommodationTypes],
["ArticleList", LazyArticleList],
["CampsiteOwner", LazyCampsiteOwner],
["HomepageBackground", LazyHomepageBackground],
["HomepageMain", LazyHomepageMain],
["PopularFeatures", LazyPopularFeatures],
["PopularSearches", LazyPopularSearches],
["PopularSearchesGlamping", LazyPopularSearchesGlamping],
["TopDestinations", LazyTopDestinations],
["SocialProofEs", LazySocialProofEs],
["SocialProofFr", LazySocialProofFr],
["SocialProofIt", LazySocialProofIt],
["SocialProofOthers", LazySocialProofOthers],
["SocialProofUsa", LazySocialProofUsa],
["SocialProof", LazySocialProof],
["AccountHome", LazyAccountHome],
["AppFooter", LazyAppFooter],
["AppFooterDesktop", LazyAppFooterDesktop],
["AppHeaderDesktop", LazyAppHeaderDesktop],
["AppHeader", LazyAppHeader],
["Copyright", LazyCopyright],
["FeefoBadge", LazyFeefoBadge],
["FooterLinks", LazyFooterLinks],
["FooterLinksDesktop", LazyFooterLinksDesktop],
["PaymentTypes", LazyPaymentTypes],
["RecentCampsites", LazyRecentCampsites],
["Version", LazyVersion],
["AppMenu", LazyAppMenu],
["AppMenuAboutUs", LazyAppMenuAboutUs],
["AppMenuCategories", LazyAppMenuCategories],
["AppMenuInternationalization", LazyAppMenuInternationalization],
["AppMenuSocialLinks", LazyAppMenuSocialLinks],
["CurrencySwitchMenu", LazyCurrencySwitchMenu],
["MegaMenu", LazyMegaMenu],
["PopularDestinations", LazyPopularDestinations],
["AppMenuLocationNode", LazyAppMenuLocationNode],
["AppMenuLocations", LazyAppMenuLocations],
["AppMenuLocationsTree", LazyAppMenuLocationsTree],
["FacebookContinueButton", LazyFacebookContinueButton],
["FacebookLoginButton", LazyFacebookLoginButton],
["GoogleLoginButton", LazyGoogleLoginButton],
["GoogleOneTap", LazyGoogleOneTap],
["LoginForm", LazyLoginForm],
["LoginMain", LazyLoginMain],
["SocialLogin", LazySocialLogin],
["StateMatches", LazyStateMatches],
["StateStringsMatches", LazyStateStringsMatches],
["PDateRange", LazyPDateRange],
["CampsiteDetail", LazyCampsiteDetail],
["CategorySearch", LazyCategorySearch],
["Fallback", LazyFallback],
["GlampingCategorySearch", LazyGlampingCategorySearch],
["SearchPage", LazySearchPage],
["Glamping2", LazyGlamping2],
["RegionalWinners", LazyRegionalWinners],
["ReviewAwardsIntro", LazyReviewAwardsIntro],
["ReviewAwardsPagesNav", LazyReviewAwardsPagesNav],
["ReviewAwardsTopSites", LazyReviewAwardsTopSites],
["ReviewDetails", LazyReviewDetails],
["SearchSummaryBar", LazySearchSummaryBar],
["SearchSummaryBarAction", LazySearchSummaryBarAction],
["SearchSummaryBarDetails", LazySearchSummaryBarDetails],
["SearchSummaryBarDetailsBounds", LazySearchSummaryBarDetailsBounds],
["SearchSummaryBarDetailsCalendar", LazySearchSummaryBarDetailsCalendar],
["SearchSummaryBarDetailsCalendarSameMonth", LazySearchSummaryBarDetailsCalendarSameMonth],
["SearchSummaryBarDetailsCategories", LazySearchSummaryBarDetailsCategories],
["SearchSummaryBarDetailsFacets", LazySearchSummaryBarDetailsFacets],
["SearchSummaryBarDetailsGuests", LazySearchSummaryBarDetailsGuests],
["SearchSummaryBarDetailsPriceRange", LazySearchSummaryBarDetailsPriceRange],
["SearchSummaryBarFilters", LazySearchSummaryBarFilters],
["SearchSummaryBarLinkMatches", LazySearchSummaryBarLinkMatches],
["SingleStar", LazySingleStar],
["StarRating", LazyStarRating],
["StarRatingAccessible", LazyStarRatingAccessible],
["BackToTop", LazyBackToTop],
["BasePhone", LazyBasePhone],
["DeleteButtonWithPrompt", LazyDeleteButtonWithPrompt],
["Error", LazyError],
["FloatingWindow", LazyFloatingWindow],
["Loading", LazyLoading],
["LoadingSpinner", LazyLoadingSpinner],
["NumberStepper", LazyNumberStepper],
["PuAccordion", LazyPuAccordion],
["PuAccordionStateless", LazyPuAccordionStateless],
["PuDate", LazyPuDate],
["PuModal", LazyPuModal],
["PuModalNoHash", LazyPuModalNoHash],
["PuPopover", LazyPuPopover],
["PuPrice", LazyPuPrice],
["PuPriceLosenge", LazyPuPriceLosenge],
["PuPriceRounded", LazyPuPriceRounded],
["PuSlideoutPanel", LazyPuSlideoutPanel],
["PuTimezone", LazyPuTimezone],
["PuUtcDate", LazyPuUtcDate],
["UiCollapse", LazyUiCollapse],
["DotBar", LazyDotBar],
["AccountDashboard", LazyAccountDashboard],
["AccountSectionsMenu", LazyAccountSectionsMenu],
["NewUser", LazyNewUser],
["RecentSearches", LazyRecentSearches],
["UserAccountFooter", LazyUserAccountFooter],
["UserAccountSection", LazyUserAccountSection],
["UserAccountUsersInfo", LazyUserAccountUsersInfo],
["UserAvatar", LazyUserAvatar],
["UserChangePassword", LazyUserChangePassword],
["UserDetails", LazyUserDetails],
["AllocationAlertForm", LazyAllocationAlertForm],
["NotifyMe", LazyNotifyMe],
["BookingCampsiteDetails", LazyBookingCampsiteDetails],
["BookingCancellationPolicy", LazyBookingCancellationPolicy],
["BookingCosts", LazyBookingCosts],
["BookingDateChanged", LazyBookingDateChanged],
["BookingDisallowedSubcategories", LazyBookingDisallowedSubcategories],
["BookingEditIcon", LazyBookingEditIcon],
["BookingEstimateTimeOfArrival", LazyBookingEstimateTimeOfArrival],
["BookingForm", LazyBookingForm],
["BookingLoadingErrorState", LazyBookingLoadingErrorState],
["BookingLoadingState", LazyBookingLoadingState],
["BookingMain", LazyBookingMain],
["BookingMessageModal", LazyBookingMessageModal],
["BookingMyDetails", LazyBookingMyDetails],
["BookingNotices", LazyBookingNotices],
["BookingOtherDetails", LazyBookingOtherDetails],
["BookingParty", LazyBookingParty],
["BookingPartyIcon", LazyBookingPartyIcon],
["BookingPaymentProcessingMain", LazyBookingPaymentProcessingMain],
["BookingPaypalButton", LazyBookingPaypalButton],
["BookingPitchDetails", LazyBookingPitchDetails],
["BookingReservationDetails", LazyBookingReservationDetails],
["BookingStayDetails", LazyBookingStayDetails],
["BookingSubmitErrorState", LazyBookingSubmitErrorState],
["BookingTaxTerms", LazyBookingTaxTerms],
["BookingThanksPageNavigate", LazyBookingThanksPageNavigate],
["BookingTimeUntilHoliday", LazyBookingTimeUntilHoliday],
["BookingTotalCost", LazyBookingTotalCost],
["BookingTotalStay", LazyBookingTotalStay],
["AdditionalTaxes", LazyAdditionalTaxes],
["ArrivalTaxes", LazyArrivalTaxes],
["ExtraChoice", LazyExtraChoice],
["ExtraChoices", LazyExtraChoices],
["AccountSection", LazyAccountSection],
["LoginModal", LazyLoginModal],
["PasswordSection", LazyPasswordSection],
["BookingArrivalTaxes", LazyBookingArrivalTaxes],
["BookingCityTax", LazyBookingCityTax],
["BookingExclusiveTaxes", LazyBookingExclusiveTaxes],
["BookingPaymentDeferred", LazyBookingPaymentDeferred],
["BookingPaymentImmediate", LazyBookingPaymentImmediate],
["BookingPaymentPitchupOnly", LazyBookingPaymentPitchupOnly],
["ApplePayButton", LazyApplePayButton],
["BasePaymentOption", LazyBasePaymentOption],
["GooglePayButton", LazyGooglePayButton],
["NewCardPaymentOption", LazyNewCardPaymentOption],
["NewCardPaymentOptionValidationErrors", LazyNewCardPaymentOptionValidationErrors],
["PaymentCard", LazyPaymentCard],
["PaymentCardForm", LazyPaymentCardForm],
["PaymentCardSaveForm", LazyPaymentCardSaveForm],
["PaymentCardSaveFormInfo", LazyPaymentCardSaveFormInfo],
["PaymentRequestButtonElement", LazyPaymentRequestButtonElement],
["PaymentsMethodsForm", LazyPaymentsMethodsForm],
["PaymentsMethodsForm2", LazyPaymentsMethodsForm2],
["RequestPaymentButton", LazyRequestPaymentButton],
["StripePaymentElement", LazyStripePaymentElement],
["StripeProvider", LazyStripeProvider],
["StoredCardPaymentOption", LazyStoredCardPaymentOption],
["StoredPaymentCardsSelector", LazyStoredPaymentCardsSelector],
["AlbumPhotos", LazyAlbumPhotos],
["AlbumVideo", LazyAlbumVideo],
["CampsiteAlbums", LazyCampsiteAlbums],
["CampsiteDescriptionDesktop", LazyCampsiteDescriptionDesktop],
["CampsiteDetailBackButton", LazyCampsiteDetailBackButton],
["CampsiteDetailBookableListing", LazyCampsiteDetailBookableListing],
["CampsiteDetailCardContent", LazyCampsiteDetailCardContent],
["CampsiteDetailFaq", LazyCampsiteDetailFaq],
["CampsiteDetailFreeListing", LazyCampsiteDetailFreeListing],
["CampsiteDetailFreeListingPromo", LazyCampsiteDetailFreeListingPromo],
["CampsiteDetailHeroDesktop", LazyCampsiteDetailHeroDesktop],
["CampsiteDetailLocationRow", LazyCampsiteDetailLocationRow],
["CampsiteDetailSearchBreadcrumbs", LazyCampsiteDetailSearchBreadcrumbs],
["CampsiteNextOpen", LazyCampsiteNextOpen],
["CampsitePageNavigation", LazyCampsitePageNavigation],
["CampsitePitchtypeDetailMain", LazyCampsitePitchtypeDetailMain],
["NearbyBookable", LazyNearbyBookable],
["NearbyBookableFooter", LazyNearbyBookableFooter],
["NearbyBookableHeader", LazyNearbyBookableHeader],
["NearbyBookableList", LazyNearbyBookableList],
["NearbyBookableMap", LazyNearbyBookableMap],
["MiniCard", LazyMiniCard],
["MiniCardDistance", LazyMiniCardDistance],
["MiniCardPrice", LazyMiniCardPrice],
["MiniCardPriceDated", LazyMiniCardPriceDated],
["PitchtypeBookingLink", LazyPitchtypeBookingLink],
["PitchtypeDatepickerAvailability", LazyPitchtypeDatepickerAvailability],
["PitchtypeDetailClose", LazyPitchtypeDetailClose],
["PitchtypeDetailsAvailabilitySection", LazyPitchtypeDetailsAvailabilitySection],
["PitchtypeEditAvailabilitySearchButton", LazyPitchtypeEditAvailabilitySearchButton],
["PitchtypeMiniAvailabilityCalendar", LazyPitchtypeMiniAvailabilityCalendar],
["PitchtypeMiniAvailabilityCalendarWithAvailability", LazyPitchtypeMiniAvailabilityCalendarWithAvailability],
["PitchtypeAlternativeStays", LazyPitchtypeAlternativeStays],
["PitchtypeMiniAvailabilityCalendarDay", LazyPitchtypeMiniAvailabilityCalendarDay],
["PitchtypeMiniAvailabilityCalendarMonth", LazyPitchtypeMiniAvailabilityCalendarMonth],
["PitchtypeMiniAvailabilityCalendarWeek", LazyPitchtypeMiniAvailabilityCalendarWeek],
["CampsiteDetailsPromoPages", LazyCampsiteDetailsPromoPages],
["CampsiteImageUploader", LazyCampsiteImageUploader],
["Filestack", LazyFilestack],
["UploadedImagePreview", LazyUploadedImagePreview],
["CampsiteAddressAndMap", LazyCampsiteAddressAndMap],
["CampsiteMapModal", LazyCampsiteMapModal],
["CampsiteParty", LazyCampsiteParty],
["DirectionsButton", LazyDirectionsButton],
["EditSearchButton", LazyEditSearchButton],
["InlineGallery", LazyInlineGallery],
["MatchingCriteriaCountText", LazyMatchingCriteriaCountText],
["NearbyTransport", LazyNearbyTransport],
["PitchTypePhotos", LazyPitchTypePhotos],
["PitchTypesGroup", LazyPitchTypesGroup],
["PitchTypesList", LazyPitchTypesList],
["PitchTypesSection", LazyPitchTypesSection],
["PrimaryPhoto", LazyPrimaryPhoto],
["PrimaryPhotoAndGallery", LazyPrimaryPhotoAndGallery],
["SearchInlineGallery", LazySearchInlineGallery],
["SubsectionsGroup", LazySubsectionsGroup],
["BasePitchTypeCard", LazyBasePitchTypeCard],
["CancellationPolicyPopover", LazyCancellationPolicyPopover],
["CostsBreakdown", LazyCostsBreakdown],
["DefaultCostsBreakdown", LazyDefaultCostsBreakdown],
["PitchTypeCardDated", LazyPitchTypeCardDated],
["PitchTypeCardNonDated", LazyPitchTypeCardNonDated],
["PitchTypeDetail", LazyPitchTypeDetail],
["PitchTypeDimensions", LazyPitchTypeDimensions],
["PitchTypeSeoCard", LazyPitchTypeSeoCard],
["PitchTypeSummary", LazyPitchTypeSummary],
["ArrivalTax", LazyArrivalTax],
["AvailabilityErrorState", LazyAvailabilityErrorState],
["BookingBalance", LazyBookingBalance],
["Capacity", LazyCapacity],
["CapacityRules", LazyCapacityRules],
["ChargeTypeState", LazyChargeTypeState],
["ExtraDated", LazyExtraDated],
["ExtraNonDated", LazyExtraNonDated],
["Extras", LazyExtras],
["Facilities", LazyFacilities],
["OffersActive", LazyOffersActive],
["PartyEdit", LazyPartyEdit],
["Persons", LazyPersons],
["PitchTypeAttributes", LazyPitchTypeAttributes],
["PitchTypeImage", LazyPitchTypeImage],
["PitchTypeOffers", LazyPitchTypeOffers],
["PitchTypeState", LazyPitchTypeState],
["PitchTypeStatusMsg", LazyPitchTypeStatusMsg],
["PitchtypesCompulsoryExtras", LazyPitchtypesCompulsoryExtras],
["PricingPeriodDated", LazyPricingPeriodDated],
["PricingPeriodNonDated", LazyPricingPeriodNonDated],
["SuperFacilities", LazySuperFacilities],
["Taxes", LazyTaxes],
["TotalStay", LazyTotalStay],
["Bedrooms", LazyBedrooms],
["OtherRestrictions", LazyOtherRestrictions],
["StripePayment", LazyStripePayment],
["StripePaymentDeferred", LazyStripePaymentDeferred],
["StripePaymentImmediate", LazyStripePaymentImmediate],
["StripePaymentPitchupOnly", LazyStripePaymentPitchupOnly],
["CampsiteActivitiesList", LazyCampsiteActivitiesList],
["CampsiteArrivalTax", LazyCampsiteArrivalTax],
["CampsiteCycleRoutes", LazyCampsiteCycleRoutes],
["CampsiteDescription", LazyCampsiteDescription],
["CampsiteDescriptionText", LazyCampsiteDescriptionText],
["CampsiteDirections", LazyCampsiteDirections],
["CampsiteFeatures", LazyCampsiteFeatures],
["CampsiteFestivals", LazyCampsiteFestivals],
["CampsiteLocalAttractions", LazyCampsiteLocalAttractions],
["CampsiteLocalAttractionsSubsection", LazyCampsiteLocalAttractionsSubsection],
["CampsiteLocation", LazyCampsiteLocation],
["CampsiteNationalTrust", LazyCampsiteNationalTrust],
["CampsiteNoDescription", LazyCampsiteNoDescription],
["CampsiteNoticesSubsection", LazyCampsiteNoticesSubsection],
["CampsiteOffers", LazyCampsiteOffers],
["CampsiteOffersSubsection", LazyCampsiteOffersSubsection],
["CampsitePaymentMethods", LazyCampsitePaymentMethods],
["CampsitePolicies", LazyCampsitePolicies],
["CampsiteReviewsSubsection", LazyCampsiteReviewsSubsection],
["CampsiteSubsection", LazyCampsiteSubsection],
["CampsiteTaxTerms", LazyCampsiteTaxTerms],
["CampsiteVisitBritain", LazyCampsiteVisitBritain],
["CampsiteWaterQuality", LazyCampsiteWaterQuality],
["DistancesNote", LazyDistancesNote],
["PaymentTerms", LazyPaymentTerms],
["PermittedArrivalDepartureTimes", LazyPermittedArrivalDepartureTimes],
["PermittedArrivalDepartureTimesSection", LazyPermittedArrivalDepartureTimesSection],
["SiteTypes", LazySiteTypes],
["CampsiteTermsAndConditions", LazyCampsiteTermsAndConditions],
["CampsiteVideo", LazyCampsiteVideo],
["CampsiteReviewsFilters", LazyCampsiteReviewsFilters],
["CampsiteReviewsGallery", LazyCampsiteReviewsGallery],
["CampsiteReviewsGalleryFullscreen", LazyCampsiteReviewsGalleryFullscreen],
["CampsiteReviewsNew", LazyCampsiteReviewsNew],
["CampsiteReviewsSummary", LazyCampsiteReviewsSummary],
["CampsiteReviewsSummaryTxt", LazyCampsiteReviewsSummaryTxt],
["CampsiteSingleReview", LazyCampsiteSingleReview],
["PuRatingBreakdown", LazyPuRatingBreakdown],
["PuRatingsDistribution", LazyPuRatingsDistribution],
["PuThemeBreakdown", LazyPuThemeBreakdown],
["PuThumbsUp", LazyPuThumbsUp],
["RatingsDistributionBar", LazyRatingsDistributionBar],
["WriteReviewButton", LazyWriteReviewButton],
["AddCampsiteReviewForm", LazyAddCampsiteReviewForm],
["CampsiteReviewRecommend", LazyCampsiteReviewRecommend],
["ReviewStarRating", LazyReviewStarRating],
["BrowseAllCategories", LazyBrowseAllCategories],
["CategoriesSelector", LazyCategoriesSelector],
["SelectedCategories", LazySelectedCategories],
["EmailConfirmed", LazyEmailConfirmed],
["CurrencySwitch", LazyCurrencySwitch],
["AlgoliaSearch", LazyAlgoliaSearch],
["FaqCategory", LazyFaqCategory],
["FaqMain", LazyFaqMain],
["FaqStandaloneMain", LazyFaqStandaloneMain],
["FavouritesIndex", LazyFavouritesIndex],
["MyFavourites", LazyMyFavourites],
["AppHeaderFavourites", LazyAppHeaderFavourites],
["AppHeaderFavouritesCount", LazyAppHeaderFavouritesCount],
["CampsiteFavouriteButton", LazyCampsiteFavouriteButton],
["FavouriteAddForm", LazyFavouriteAddForm],
["FavouriteAddFormWishlist", LazyFavouriteAddFormWishlist],
["FavouriteCampsitesList", LazyFavouriteCampsitesList],
["FavouriteListElement", LazyFavouriteListElement],
["FavouriteListPrivacyPopover", LazyFavouriteListPrivacyPopover],
["FavouritesMap", LazyFavouritesMap],
["FavouritesOnboarding", LazyFavouritesOnboarding],
["NoFavourites", LazyNoFavourites],
["WishlistButton", LazyWishlistButton],
["WishlistElement", LazyWishlistElement],
["WishlistFormInputs", LazyWishlistFormInputs],
["WishlistMain", LazyWishlistMain],
["FlatPageComponent", LazyFlatPageComponent],
["Error404", LazyError404],
["FooterSeoLinks", LazyFooterSeoLinks],
["GoogleTranslateButton", LazyGoogleTranslateButton],
["TranslateToLanguage", LazyTranslateToLanguage],
["LanguageSwitch", LazyLanguageSwitch],
["MapsPage", LazyMapsPage],
["MapsPageMobile", LazyMapsPageMobile],
["MapsMain", LazyMapsMain],
["PuMapStatic", LazyPuMapStatic],
["UkRegionsMap", LazyUkRegionsMap],
["CampsiteMapCard", LazyCampsiteMapCard],
["CampsiteMapCardButton", LazyCampsiteMapCardButton],
["CampsiteMapCardPrice", LazyCampsiteMapCardPrice],
["CampsiteResultsMap", LazyCampsiteResultsMap],
["CampsitesMap", LazyCampsitesMap],
["CampsitesMarkersOnlyMap", LazyCampsitesMarkersOnlyMap],
["PuMap", LazyPuMap],
["NationalParks", LazyNationalParks],
["PagePart", LazyPagePart],
["PaymentProcessingMain", LazyPaymentProcessingMain],
["PersonalDetailsForm", LazyPersonalDetailsForm],
["PersonalDetailsShow", LazyPersonalDetailsShow],
["PersonalDetails", LazyPersonalDetails],
["AddReviewBanner", LazyAddReviewBanner],
["AddReviewButton", LazyAddReviewButton],
["PostReviewMain", LazyPostReviewMain],
["AddAReview", LazyAddAReview],
["ServerErrorMessages", LazyServerErrorMessages],
["PuBookingLink", LazyPuBookingLink],
["PuCampsiteAvailabilityLink", LazyPuCampsiteAvailabilityLink],
["PuCampsiteLink", LazyPuCampsiteLink],
["PuHomepageLink", LazyPuHomepageLink],
["PuSearchWizardLink", LazyPuSearchWizardLink],
["PuSearchLink", LazyPuSearchLink],
["ResendConfirmationEmailMain", LazyResendConfirmationEmailMain],
["AvailabilityCheckWizardMain", LazyAvailabilityCheckWizardMain],
["CampsitesSearchWizardMain", LazyCampsitesSearchWizardMain],
["CampsitesSearchWizardSearchButton", LazyCampsitesSearchWizardSearchButton],
["SearchBarDesktop", LazySearchBarDesktop],
["LocationSection", LazyLocationSection],
["LocationSectionSuggestableInput", LazyLocationSectionSuggestableInput],
["PuAutoSuggest", LazyPuAutoSuggest],
["WithinInput", LazyWithinInput],
["LocationWizardSuggestionLine", LazyLocationWizardSuggestionLine],
["GroupBooking", LazyGroupBooking],
["WizardContainer", LazyWizardContainer],
["WizardFooter", LazyWizardFooter],
["SearchWizardHomepageBanner", LazySearchWizardHomepageBanner],
["SearchWizardHomepageBannerCategories", LazySearchWizardHomepageBannerCategories],
["SearchWizardHomepageBannerOptions", LazySearchWizardHomepageBannerOptions],
["SearchWizardHomepageBannerOptionsDates", LazySearchWizardHomepageBannerOptionsDates],
["SearchWizardHomepageBannerOptionsParty", LazySearchWizardHomepageBannerOptionsParty],
["AccommodationWizard", LazyAccommodationWizard],
["AccommodationWizardSummary", LazyAccommodationWizardSummary],
["DatesWizard", LazyDatesWizard],
["WizardSection", LazyWizardSection],
["GuestsWizard", LazyGuestsWizard],
["GuestsWizardBody", LazyGuestsWizardBody],
["GuestsWizardSummary", LazyGuestsWizardSummary],
["SearchCountries", LazySearchCountries],
["SearchEngagementDestinations", LazySearchEngagementDestinations],
["SearchEngagementNarrowLinks", LazySearchEngagementNarrowLinks],
["SearchMain", LazySearchMain],
["SearchNavBar", LazySearchNavBar],
["SearchProvider", LazySearchProvider],
["SearchResultsDescription", LazySearchResultsDescription],
["SearchResultsEngagementFacets", LazySearchResultsEngagementFacets],
["SearchResultsFaq", LazySearchResultsFaq],
["SearchResultsList", LazySearchResultsList],
["SearchResultsPaginationControls", LazySearchResultsPaginationControls],
["FilterAndSortCategories", LazyFilterAndSortCategories],
["FilterAndSortFooter", LazyFilterAndSortFooter],
["FilterAndSortLocation", LazyFilterAndSortLocation],
["FilterAndSortMain", LazyFilterAndSortMain],
["FilterAndSortNavItem", LazyFilterAndSortNavItem],
["FilterAndSortPrice", LazyFilterAndSortPrice],
["FilterAndSortPriceSlider", LazyFilterAndSortPriceSlider],
["FilterAndSortPriceSliderHistogram", LazyFilterAndSortPriceSliderHistogram],
["FilterAndSortRadius", LazyFilterAndSortRadius],
["FilterAndSortSortOptions", LazyFilterAndSortSortOptions],
["FilterPanel", LazyFilterPanel],
["SortSelect", LazySortSelect],
["FilterAndSortFacets", LazyFilterAndSortFacets],
["FilterAndSortFacetsGroupDefault", LazyFilterAndSortFacetsGroupDefault],
["FilterAndSortFacetsGroupRanked", LazyFilterAndSortFacetsGroupRanked],
["LowResultsAllCountries", LazyLowResultsAllCountries],
["LowResultsBounds", LazyLowResultsBounds],
["LowResultsCategories", LazyLowResultsCategories],
["LowResultsCitySearch", LazyLowResultsCitySearch],
["LowResultsDates", LazyLowResultsDates],
["LowResultsFacets", LazyLowResultsFacets],
["LowResultsHierarchy", LazyLowResultsHierarchy],
["LowResultsPoint", LazyLowResultsPoint],
["LowResultsPriceRange", LazyLowResultsPriceRange],
["PuLowResultsSearchLink", LazyPuLowResultsSearchLink],
["SearchLowResult", LazySearchLowResult],
["SearchSummaryAvailabilitySearch", LazySearchSummaryAvailabilitySearch],
["SearchSummaryBookableCountSearch", LazySearchSummaryBookableCountSearch],
["SearchSummaryListing", LazySearchSummaryListing],
["SearchSummaryMain", LazySearchSummaryMain],
["SearchResultsPopularLocations", LazySearchResultsPopularLocations],
["SignupForm", LazySignupForm],
["ThanksMain", LazyThanksMain],
["ThanksPage", LazyThanksPage],
["ThanksPageContactTheSite", LazyThanksPageContactTheSite],
["HowDidYouHearAboutUs", LazyHowDidYouHearAboutUs],
["BalanceStatusButton", LazyBalanceStatusButton],
["BookingDetail", LazyBookingDetail],
["BookingSummary", LazyBookingSummary],
["CampsiteSummary", LazyCampsiteSummary],
["ChangeCardModal", LazyChangeCardModal],
["NextHoliday", LazyNextHoliday],
["UserBookingMain", LazyUserBookingMain],
["UserBookingTaxes", LazyUserBookingTaxes],
["UserBookings", LazyUserBookings],
["UserBookingsMain", LazyUserBookingsMain],
["ChangeEmailMain", LazyChangeEmailMain],
["ChangeEmailForm", LazyChangeEmailForm],
["ChangeEmailPendingEmails", LazyChangeEmailPendingEmails],
["UserAccountDetails", LazyUserAccountDetails],
["UserDetailsForm", LazyUserDetailsForm],
["AllocationAlert", LazyAllocationAlert],
["LocationAllocationAlert", LazyLocationAllocationAlert],
["UserAvailabilityAlertsMain", LazyUserAvailabilityAlertsMain],
["ResetPassword", LazyResetPassword],
["ResetPasswordConfirmation", LazyResetPasswordConfirmation],
["ResetPasswordConfirmationMain", LazyResetPasswordConfirmationMain],
["UserReviewsMain", LazyUserReviewsMain],
["PendingReviews", LazyPendingReviews],
["UserSettingsMain", LazyUserSettingsMain],
["BookingNotificationsSettings", LazyBookingNotificationsSettings],
["DistanceUnitSettings", LazyDistanceUnitSettings],
["EmailPreferencesSettings", LazyEmailPreferencesSettings],
["FavouritesSettings", LazyFavouritesSettings],
["LanguageSettings", LazyLanguageSettings],
["MapStyleSettings", LazyMapStyleSettings],
["RecommendationsAndOffersSettings", LazyRecommendationsAndOffersSettings],
["TemperatureUnitSettings", LazyTemperatureUnitSettings],
["WebsiteDataSettings", LazyWebsiteDataSettings],
["UserStoredCard", LazyUserStoredCard],
["UserStoredCards", LazyUserStoredCards],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
